// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Orders_AgendaMensalResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET /so/orders/agenda_mensal
 *
 * Groups PENDING order items by their expected delivery day within
 * the requested month. The client renders these as a monthly calendar
 * grid with urgency-colored cards per day.
 */
import type { Orders_AgendaMensalItemRow } from './Orders_AgendaMensalItemRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Orders_AgendaMensalResponseDados {
year: number
month: number
days: {
day: number,
date: string,
items: Orders_AgendaMensalItemRow[],
}[]
}

export type Orders_AgendaMensalResponse = ApiResponse<Orders_AgendaMensalResponseDados>;

registerResponseContract('Orders_AgendaMensalResponse', {
  year:  { type: 'number',  required: true },
  month: { type: 'number',  required: true },
  days:  { type: 'array',   required: true },
})
